import React from "react";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { EventsIcons } from "../../../../../models/marine.traffic";
import { ProgressBarContainerEvent } from "../../../index";
import { LocationIcon } from "../../styles";
import EventBadgeStatus from "../EventStatus";
import {
  Divider,
  LocationWrapper,
  PlaneIcon,
  ShipIcon,
  Subtitle,
  Text,
  Wrapper,
  useStyles,
} from "./styles";

interface Props {
  event: ProgressBarContainerEvent;
  last: boolean;
  isAirTracking?: boolean;
}

const EventItem = ({ event, last, isAirTracking }: Props) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <Wrapper>
      <Box width="100%" className={classes.eventItemFlex}>
        <Box className={classes.eventItemFlex}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Box className={classes.eventItemFlex}>
              <Subtitle>{translate(event.eventTypeDescription)}</Subtitle>
              <Text>{event.nextEventDateTime || translate("empty")}</Text>
            </Box>
            <Box display={"flex"} justifyContent={"center"} alignItems={"flex-start"}>
              <EventBadgeStatus value={event.status} />
            </Box>
          </Box>
          <LocationWrapper flexDirection={"row"} style={{ gap: 24 }}>
            <Box display={"flex"}>
              <LocationIcon size={16} />
              <Text>{event?.eventLocationName || translate("empty")}</Text>
            </Box>
            <Box display={"flex"}>
              {event?.iconName === EventsIcons.PLANE ? (
                <PlaneIcon size={16} />
              ) : (
                <ShipIcon size={16} />
              )}
              <Text>{event?.vesselName || translate("empty")}</Text>
            </Box>
          </LocationWrapper>
        </Box>
        {!last && <Divider />}
      </Box>
    </Wrapper>
  );
};

export default EventItem;
